import React from "react";
import { InvoiceList } from "@/pages/Invoices";

export default function Estimates() {
    return <InvoiceList kind="estimate" />;
}
